export  const installDictionary = {
iosInstall:{fa:"نصب  بازیگرام در 3 مرحله" , en:"Installing Bazigram in 3 steps"},
select:{fa:"انتخاب" , en:"Select"},
bottomBar:{fa:"در نوار پایین" , en:"In the bottom bar"},
right:{fa:"در قسمت پایین سمت راست" , en:"In the lower right part"},
top:{fa:"در بالا، سمت راست" , en:"above, right"},
androidInstall:{fa:"نصب  بازیگرام در 2 مرحله" , en:"Installing Bazigram in 2 steps"},
topBar:{fa:"در نوار بالا، سمت راست" , en:"In the top right bar"},
expandedMenu:{fa:"از منوی باز شده" , en:"from expanded menu"},
}